import React from 'react';
import styled from 'styled-components';
import E500 from "../assets/newSvg/error/500.png"
import PageTitlesFunc from "../components/Functions/PageTitlesFunc"
// import MainImage from '../assets/404/404-1 (1).png';

const Style = styled.div`
        display:flex ;
        flex-direction: column;
        position: relative;
        direction: rtl;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        margin: 0;
        .back-img{
            position: absolute;
            inset: 0;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
        .error-feild{
            display:grid ;
            grid-template-columns: repeat(2 , 50%);
            align-items: center;
            position: relative;
            margin: 10rem 0;     
            .error-code{
                padding: 1rem;
                width: calc(100% - 2rem);
                display: flex;
                flex-direction: column; 
                .code{
                    width: 85%;
                    position: relative;
                    display: flex;
                    color: #000;
                    -webkit-text-stroke-color: #858DA4;
                    -webkit-text-stroke-width: 2px;
                    font-size: 240px;
                    font-weight: 900;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    margin: auto;
                }
                .line{
                    width: 70%;
                    height: 2px;
                    background: #858DA4;
                    margin: -2rem auto;
                }
            }
            .error-text{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .error-mgs{
                    font-size: 2.5rem;
                    font-weight: 400;
                    color: #FFF
                }
                .error-desc{
                    font-size: 1.2rem;
                    font-weight: 500;
                    color: #979797;
                    margin: 1rem 0 2rem;
                }
                .error-back{
                    font-size: 0.87rem;
                    font-weight: 400;
                    color: #FFF;
                    border:1px solid #FFF ;
                    border-radius: 4px;
                    display: flex;
                    background: none;
                    flex-direction: row;
                    align-items: center;
                    width: max-content;
                    padding: 0.5rem ;
                    text-decoration: none;
                    .arrow-circle{
                        border: 1px solid #FFF;
                        border-radius: 50px;
                        padding: 0.2rem;
                        transform: rotate(180deg);
                        fill: #FFF;
                        width: 1rem;
                        height: 1rem;
                        aspect-ratio: 1;
                        margin-right: 0.2rem;
                    }
                }
            }
        }
        @media screen and (max-width: 850px) {
            padding: 5rem 0; 
            .back-img{
                height: 100vh;
            }
            .error-feild{
                grid-template-columns: 1fr;
                margin: 0 auto;
                .error-back{
                    margin: auto;
                }
                .error-text{
                    margin: 0 var(--padding);
                    .error-mgs{
                        font-size: 1.5rem;
                        margin: auto;
                    }
                    .error-desc{
                        text-align: center;
                        font-size: 1rem;
                    }
                }
                .error-code{
                    .code{
                        width: 100%;
                        font-size: 100px;
                    }
                    .line{
                        margin-top: 0;
                        margin-bottom: 2rem;
                        width: 100%;
                    }
                }
            }
        }
`

class ErrorPage extends React.Component {
    componentDidMount(){
        PageTitlesFunc({
            title: "یه مشکلی پیش اومده"
        });
    }
    render() {
      return (
        <Style>
            <img alt='error-page' src={E500}class="back-img"/>
            <div class="error-feild">
                <div class="error-code">
                    <span class="code">500</span>
                    <span class="line"></span>
                </div>
                <div class="error-text"> 
                    <span class="error-mgs">
                    یه مشکلی پیش اومده!
                    </span>
                    <span class="error-desc">
                    یه جای کار میلنگه!
                    </span>
                    <a href='/' class="error-back">
                        بازگشت به صفحه اصلی
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-circle">
                            <path d="M19.2398 25.0934C18.9865 25.0934 18.7332 25 18.5332 24.8C18.1465 24.4134 18.1465 23.7734 18.5332 23.3867L25.9198 16L18.5332 8.61337C18.1465 8.2267 18.1465 7.5867 18.5332 7.20003C18.9198 6.81337 19.5598 6.81337 19.9465 7.20003L28.0398 15.2934C28.4265 15.68 28.4265 16.32 28.0398 16.7067L19.9465 24.8C19.7465 25 19.4932 25.0934 19.2398 25.0934Z" />
                            <path d="M27.107 17H4.66699C4.12033 17 3.66699 16.5467 3.66699 16C3.66699 15.4533 4.12033 15 4.66699 15H27.107C27.6537 15 28.107 15.4533 28.107 16C28.107 16.5467 27.6537 17 27.107 17Z" />
                        </svg>
                    </a>
                </div>
            </div>
        </Style>
      ); 
    }
}

export default ErrorPage
